import { render } from "./page3.vue?vue&type=template&id=4dd8e79c"
import script from "./page3.vue?vue&type=script&lang=js"
export * from "./page3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__